import { render, staticRenderFns } from "./DetaliiAviz.vue?vue&type=template&id=80ee0d60"
import script from "./DetaliiAviz.vue?vue&type=script&lang=js"
export * from "./DetaliiAviz.vue?vue&type=script&lang=js"
import style0 from "./DetaliiAviz.vue?vue&type=style&index=0&id=80ee0d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports